var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "section", staticStyle: { width: "1700px" } },
      [
        _c("div", { staticClass: "app-main-inner-row operations" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.cooperateEdit,
                  expression: "cooperateEdit"
                }
              ],
              staticClass: "triggers"
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.isEdit,
                        no: "exportPackingInfo",
                        type: "primary"
                      },
                      on: { click: _vm.exportTruckExcelData }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.ExportPackingInfo")) + " "
                      )
                    ]
                  ),
                  _c(
                    "el-upload",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "padding-left": "5px"
                      },
                      attrs: {
                        disabled: _vm.isEdit || _vm.job.jobState > 0,
                        action: "string",
                        "http-request": _vm.importTruckDataExcel,
                        "show-file-list": false,
                        accept: ".xls, .xlsx",
                        "before-upload": _vm.beforeUploadUsage
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "importPackingInfo",
                            type: "primary",
                            disabled: _vm.isEdit || _vm.job.jobState > 0
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("SeaExport.ImportPackingInfo")) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "exportErrorExcel",
                        type: "primary",
                        disabled: _vm.isEdit && !_vm.importExcelResultID
                      },
                      on: { click: _vm.exportErrorExcel }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.DownloadImportResults")) + " "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        ]),
        _c(
          "div",
          { staticStyle: { "flex-grow": "1", padding: "10px" } },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%", height: "300px" },
              attrs: {
                no: "gridCabinets",
                "grid-options": _vm.gridOptions,
                "grid-params": _vm.gridParams,
                "column-defs": _vm.cabinetColumnDefs,
                "row-data": _vm.job.containerUsages || []
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                },
                gridReady: function(params) {
                  return (_vm.gridApi = params.api)
                }
              }
            })
          ],
          1
        ),
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.DoorToDoorLoading")) + " "),
          _c(
            "span",
            {
              staticStyle: {
                color: "red",
                "font-weight": "lighter",
                margin: "30px"
              }
            },
            [
              _vm._v(
                _vm._s(_vm.$t("SeaExport.SaveBusinessBeforeEnterMultiGate2"))
              )
            ]
          )
        ]),
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "inline-form",
                    attrs: {
                      inline: true,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { staticStyle: { width: "460px" } },
                      [
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { width: "auto" },
                            attrs: { no: "5.1", disabled: _vm.readonly },
                            model: {
                              value: _vm.truckingInfo.sameTransportationCompany,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.truckingInfo,
                                  "sameTransportationCompany",
                                  $$v
                                )
                              },
                              expression:
                                "truckingInfo.sameTransportationCompany"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.SameTransportationCompany")
                              ) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { width: "auto" },
                            attrs: { no: "5.2", disabled: _vm.readonly },
                            model: {
                              value: _vm.truckingInfo.sameDoorPoint,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "sameDoorPoint", $$v)
                              },
                              expression: "truckingInfo.sameDoorPoint"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("SeaExport.SameDoorPoint")) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c("label", { staticStyle: { width: "55px" } }, [
                          _vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))
                        ]),
                        _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: {
                            no: "6",
                            value: _vm.truckingInfo.quantity || undefined,
                            disabled: _vm.readonly,
                            min: 0,
                            max: 99999,
                            precision: 0,
                            "controls-position": "right"
                          },
                          on: {
                            input: function(event) {
                              return _vm.truckDataChange(event, "quantity")
                            }
                          }
                        }),
                        _c("label", { staticStyle: { width: "55px" } }, [
                          _vm._v(_vm._s(_vm.$t("SeaExport.Weight")))
                        ]),
                        _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: {
                            no: "7",
                            value: _vm.truckingInfo.weight || undefined,
                            disabled: _vm.readonly,
                            min: 0,
                            max: 99999,
                            precision: 3,
                            "controls-position": "right"
                          },
                          on: {
                            input: function(event) {
                              return _vm.truckDataChange(event, "weight")
                            }
                          }
                        }),
                        _c("label", { staticStyle: { width: "55px" } }, [
                          _vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))
                        ]),
                        _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: {
                            no: "8",
                            value: _vm.truckingInfo.cubage || undefined,
                            disabled: _vm.readonly,
                            min: 0,
                            max: 99999,
                            precision: 3,
                            "controls-position": "right"
                          },
                          on: {
                            input: function(event) {
                              return _vm.truckDataChange(event, "cubage")
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "trucking-form" },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: _vm.readonly,
                          "label-width": "140px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.HaulageCompany") }
                          },
                          [
                            _c("cargo-company-select", {
                              staticStyle: {
                                width: "350px",
                                display: "inline-block"
                              },
                              attrs: {
                                no: "9",
                                disabled: _vm.readonly,
                                "method-params": {
                                  truckCmp: true,
                                  active: true
                                },
                                "default-value":
                                  _vm.truckingInfo.carryingCmp || ""
                              },
                              on: {
                                change: function(p) {
                                  _vm.truckingInfo.carryingCmp = p.value || 0
                                  _vm.carryingCmpChangeHandler()
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("SeaExport.HaulageContactPerson")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "350px" },
                                attrs: {
                                  no: "10",
                                  placeholder: _vm.readonly
                                    ? ""
                                    : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                  "allow-create": true,
                                  clearable: true,
                                  filterable: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.carryingContactsChangeHandler(
                                      false,
                                      false
                                    )
                                  },
                                  blur: _vm.selectContactBlur
                                },
                                model: {
                                  value: _vm.truckingInfo.driver,
                                  callback: function($$v) {
                                    _vm.$set(_vm.truckingInfo, "driver", $$v)
                                  },
                                  expression: "truckingInfo.driver"
                                }
                              },
                              _vm._l(_vm.carryingContacts, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.contactPerson,
                                    value: item.contactPerson
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("SeaExport.EstimatedPackingDate")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "350px" },
                              attrs: {
                                no: "11",
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm"
                              },
                              on: {
                                input: function(event) {
                                  return _vm.truckDataChange(
                                    event,
                                    "loadingDate"
                                  )
                                }
                              },
                              model: {
                                value: _vm.truckingInfo.loadingDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "loadingDate", $$v)
                                },
                                expression: "truckingInfo.loadingDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("SeaExport.ExpectedArrivalDate2")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "350px" },
                              attrs: {
                                no: "arrivalDate",
                                disabled: true,
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm"
                              },
                              model: {
                                value: _vm.ieTruckInfo.arriveDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.ieTruckInfo, "arriveDate", $$v)
                                },
                                expression: "ieTruckInfo.arriveDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("Warehouse.Driver"),
                              disabled: _vm.txtEditEable
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "350px" },
                              attrs: { no: "12" },
                              on: {
                                blur: function(event) {
                                  return _vm.truckDataChange(
                                    event,
                                    "driverName"
                                  )
                                }
                              },
                              model: {
                                value: _vm.truckingInfo.driverName,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "driverName", $$v)
                                },
                                expression: "truckingInfo.driverName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("Warehouse.DriverPhone"),
                              disabled: _vm.txtEditEable
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "350px" },
                              attrs: { no: "45", disabled: _vm.readonly },
                              on: {
                                blur: function(event) {
                                  return _vm.truckDataChange(
                                    event,
                                    "driverPhone"
                                  )
                                }
                              },
                              model: {
                                value: _vm.truckingInfo.driverPhone,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "driverPhone", $$v)
                                },
                                expression: "truckingInfo.driverPhone"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("SeaExport.CarryingCaseYard"),
                              disabled: _vm.txtEditEable
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "350px" },
                              attrs: { no: "45", disabled: _vm.readonly },
                              model: {
                                value: _vm.selectedData.truckingPlaceOfDep,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.selectedData,
                                    "truckingPlaceOfDep",
                                    $$v
                                  )
                                },
                                expression: "selectedData.truckingPlaceOfDep"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.Door") }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center"
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "270px" },
                                  attrs: {
                                    filterable: "",
                                    cache: false,
                                    "allow-create": true,
                                    placeholder: _vm.readonly
                                      ? ""
                                      : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                    disabled: _vm.readonly,
                                    "tag-name": "name",
                                    "tag-value": "name",
                                    "default-value": _vm.truckingInfo.doorName,
                                    "static-options": _vm.doorList,
                                    "filter-tag-names": ["name"]
                                  },
                                  on: { parentCallBack: _vm.doorsChangeHandler }
                                }),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.$checkPermission([
                                          "button_Common_AddSite"
                                        ]),
                                        expression:
                                          "$checkPermission(['button_Common_AddSite'])"
                                      }
                                    ],
                                    staticClass: "vehicle-btn",
                                    attrs: {
                                      no: "addDoor",
                                      disabled: !_vm.isEdit,
                                      type: "primary",
                                      size: "mini"
                                    },
                                    on: { click: _vm.addDoor }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Partners.doorInformation"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.DoorAddress") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "350px" },
                              attrs: { no: "16", type: "textarea", rows: 3 },
                              on: {
                                blur: function(event) {
                                  return _vm.doorChangeHandler(
                                    event,
                                    "doorAddr"
                                  )
                                }
                              },
                              model: {
                                value: _vm.truckingInfo.doorAddr,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "doorAddr", $$v)
                                },
                                expression: "truckingInfo.doorAddr"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { "label-width": "0" }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "custom",
                                    attrs: {
                                      label: _vm.$t("Pricing.BelongingCity")
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "140px" },
                                      attrs: {
                                        no: "17",
                                        disabled: _vm.readonly,
                                        "tag-name":
                                          _vm.$store.getters.language === "zh"
                                            ? "chineseName"
                                            : "englishName",
                                        "tag-value": "code",
                                        cache: false,
                                        filterable: "",
                                        "default-value":
                                          _vm.truckingInfo.cityCode,
                                        "static-options": _vm.cityList,
                                        placeholder: _vm.$t(
                                          "SeaExport.PleaseSelect"
                                        )
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.truckingInfo.cityCode = p.value
                                          _vm.cityChangeHandler(p.value)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form",
                                  {
                                    attrs: {
                                      "label-width": "100px",
                                      "label-position": "left"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "custom",
                                        attrs: {
                                          label: _vm.$t("Warehouse.PalletSum")
                                        }
                                      },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { width: "110px" },
                                          attrs: {
                                            no: "18",
                                            value: _vm.truckingInfo.palletSum,
                                            disabled: _vm.readonly,
                                            min: 0,
                                            max: 999999999999,
                                            precision: 0,
                                            controls: false
                                          },
                                          on: {
                                            input: function(val) {
                                              _vm.truckingInfo.palletSum =
                                                val || 0
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "PO" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "350px" },
                              attrs: {
                                no: "po",
                                disabled: _vm.readonly,
                                "filter-chars": false,
                                type: "textarea",
                                rows: 3
                              },
                              model: {
                                value: _vm.truckingInfo.po,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "po", $$v)
                                },
                                expression: "truckingInfo.po"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "140px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.HaulageNo") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "140px" },
                              attrs: { no: "19", disabled: _vm.readonly },
                              on: { change: _vm.refreshGrid },
                              model: {
                                value: _vm.truckingInfo.truckOrderNo,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.truckingInfo,
                                    "truckOrderNo",
                                    $$v
                                  )
                                },
                                expression: "truckingInfo.truckOrderNo"
                              }
                            }),
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("SeaExport.HaulageCharge")))
                            ]),
                            _c("el-input-number", {
                              staticStyle: { width: "110px" },
                              attrs: {
                                no: "40",
                                disabled: _vm.readonly,
                                min: 0,
                                max: 999999999999,
                                precision: 2,
                                "controls-position": "right"
                              },
                              on: { change: _vm.truckingFeeCharge },
                              model: {
                                value: _vm.truckingInfo.truckingFee,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "truckingFee", $$v)
                                },
                                expression: "truckingInfo.truckingFee"
                              }
                            }),
                            _c("span", { staticClass: "currency" }, [
                              _vm._v(_vm._s(_vm.localCurrency))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.Tel") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "350px" },
                              attrs: { no: "41", disabled: _vm.readonly },
                              on: { change: _vm.driverTelChargeHandler },
                              model: {
                                value: _vm.truckingInfo.driverTel,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "driverTel", $$v)
                                },
                                expression: "truckingInfo.driverTel"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("SeaExport.ActualPackingDate")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "350px" },
                              attrs: {
                                no: "42",
                                disabled: _vm.readonly,
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm"
                              },
                              on: {
                                input: function(event) {
                                  return _vm.truckDataChange(
                                    event,
                                    "actLoadingDate"
                                  )
                                }
                              },
                              model: {
                                value: _vm.truckingInfo.actLoadingDate,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.truckingInfo,
                                    "actLoadingDate",
                                    $$v
                                  )
                                },
                                expression: "truckingInfo.actLoadingDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("SeaExport.ActualArrivalDate")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "350px" },
                              attrs: {
                                no: "actualArrivalDate",
                                disabled: true,
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm"
                              },
                              model: {
                                value: _vm.ieTruckInfo.actualArrivalDate,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.ieTruckInfo,
                                    "actualArrivalDate",
                                    $$v
                                  )
                                },
                                expression: "ieTruckInfo.actualArrivalDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_VehicleModel")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "350px" },
                              attrs: {
                                no: "vehicleType",
                                disabled: _vm.readonly,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_VehicleModel,
                                filterable: "",
                                "method-params": { typeTc: true },
                                clearable: false,
                                "default-value": _vm.job.vehicleType
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.job.vehicleType = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.PlateNumber") }
                          },
                          [
                            _vm.isEdit
                              ? _c("el-input", {
                                  staticStyle: { width: "230px" },
                                  attrs: { no: "43", disabled: _vm.readonly },
                                  on: {
                                    blur: function(event) {
                                      return _vm.truckDataChange(
                                        event,
                                        "plateNumber"
                                      )
                                    },
                                    input: function(val) {
                                      _vm.truckingInfo.plateNumber = val.trim()
                                    }
                                  },
                                  model: {
                                    value: _vm.truckingInfo.plateNumber,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.truckingInfo,
                                        "plateNumber",
                                        $$v
                                      )
                                    },
                                    expression: "truckingInfo.plateNumber"
                                  }
                                })
                              : _vm._e(),
                            _vm.readonly
                              ? _c("span", { staticClass: "plate_number" }, [
                                  _vm._v(_vm._s(_vm.truckingInfo.plateNumber))
                                ])
                              : _vm._e(),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "light",
                                  content: _vm.$t(
                                    "SeaExport.ClickVehiclePositioningAndTrack"
                                  ),
                                  placement: "top"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question vehicle-tip"
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.DriverIDCard") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "350px" },
                              attrs: { no: "15", disabled: _vm.readonly },
                              on: {
                                blur: function(event) {
                                  return _vm.truckDataChange(
                                    event,
                                    "driverIdCard"
                                  )
                                }
                              },
                              model: {
                                value: _vm.truckingInfo.driverIdCard,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.truckingInfo,
                                    "driverIdCard",
                                    $$v
                                  )
                                },
                                expression: "truckingInfo.driverIdCard"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.ReturnYard") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "350px" },
                              attrs: { no: "15", disabled: _vm.readonly },
                              model: {
                                value: _vm.selectedData.truckingPlaceOfDest,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.selectedData,
                                    "truckingPlaceOfDest",
                                    $$v
                                  )
                                },
                                expression: "selectedData.truckingPlaceOfDest"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("SeaExport.DoorContactPerson")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "350px" },
                              attrs: { no: "15", disabled: _vm.readonly },
                              on: {
                                blur: function(event) {
                                  return _vm.doorChangeHandler(event, "doorMan")
                                }
                              },
                              model: {
                                value: _vm.truckingInfo.doorMan,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "doorMan", $$v)
                                },
                                expression: "truckingInfo.doorMan"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.Tel") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "350px" },
                              attrs: { no: "46", disabled: _vm.readonly },
                              on: {
                                blur: function(event) {
                                  return _vm.doorChangeHandler(
                                    event,
                                    "doorManTel"
                                  )
                                }
                              },
                              model: {
                                value: _vm.truckingInfo.doorManTel,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "doorManTel", $$v)
                                },
                                expression: "truckingInfo.doorManTel"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.AdditionalNotes")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "350px" },
                              attrs: {
                                no: "47",
                                disabled: _vm.readonly,
                                "filter-chars": false,
                                type: "textarea",
                                rows: 3
                              },
                              on: {
                                blur: function(event) {
                                  return _vm.truckDataChange(event, "remarks")
                                }
                              },
                              model: {
                                value: _vm.truckingInfo.remarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "remarks", $$v)
                                },
                                expression: "truckingInfo.remarks"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.travelTime") }
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "105px" },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "13",
                                min: 0,
                                "controls-position": "right"
                              },
                              model: {
                                value: _vm.truckingInfo.travelHour,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "travelHour", $$v)
                                },
                                expression: "truckingInfo.travelHour"
                              }
                            }),
                            _c("span", { staticStyle: { margin: "10px" } }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.Hour")))
                            ]),
                            _c("el-input-number", {
                              staticStyle: { width: "100px" },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "14",
                                min: 0,
                                max: 59,
                                "controls-position": "right"
                              },
                              model: {
                                value: _vm.truckingInfo.travelMinute,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.truckingInfo,
                                    "travelMinute",
                                    $$v
                                  )
                                },
                                expression: "truckingInfo.travelMinute"
                              }
                            }),
                            _c("span", { staticStyle: { margin: "10px" } }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.Minute")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-form",
              { attrs: { "label-width": "70px", "label-position": "left" } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { label: _vm.$t("SeaExport.ContainerNo") }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "250px" },
                      attrs: { no: "containerNo", disabled: _vm.readonly },
                      on: {
                        blur: function(event) {
                          return _vm.truckDataChange(event, "containerNo")
                        }
                      },
                      model: {
                        value: _vm.selectedData.containerNo,
                        callback: function($$v) {
                          _vm.$set(_vm.selectedData, "containerNo", $$v)
                        },
                        expression: "selectedData.containerNo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { label: _vm.$t("SeaExport.SealNo") }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "250px" },
                      attrs: { no: "sealNo", disabled: _vm.readonly },
                      on: {
                        blur: function(event) {
                          return _vm.truckDataChange(event, "sealNo")
                        }
                      },
                      model: {
                        value: _vm.selectedData.sealNo,
                        callback: function($$v) {
                          _vm.$set(_vm.selectedData, "sealNo", $$v)
                        },
                        expression: "selectedData.sealNo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { label: _vm.$t("SeaExport.EmptyContainerWeight") }
                  },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        no: "7",
                        disabled: _vm.readonly,
                        min: 0,
                        max: 99999,
                        precision: 3,
                        "controls-position": "right"
                      },
                      on: {
                        input: function(event) {
                          return _vm.truckDataChange(event, "containerWeight")
                        }
                      },
                      model: {
                        value: _vm.truckingInfo.containerWeight,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "containerWeight", $$v)
                        },
                        expression: "truckingInfo.containerWeight"
                      }
                    }),
                    _vm._v(" KG ")
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c("door-point-information", {
          attrs: {
            "v-if": _vm.addDoorDialog.visible,
            visible: _vm.addDoorDialog.visible,
            action: _vm.action,
            site: _vm.addDoorDialog.form
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.addDoorDialog, "visible", $event)
            },
            loadSites: _vm.loadSites
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }